import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Dialog, makeStyles } from '@applyboard/ui-components';
import { useOnboardingFormControllerContext } from "../../controller/OnboardingFormController";
var DesktopDialog = function DesktopDialog(_ref) {
  var children = _ref.children;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    background = _useOnboardingFormCon.background;
  var useStyles = makeStyles({
    dialog: {
      backgroundImage: function backgroundImage(p) {
        return "url(".concat(p.background, ")");
      },
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom right',
      backgroundSize: 'cover'
    }
  });
  var dialogStyles = useStyles({
    background: background
  });
  return /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    open: true,
    classes: {
      paper: dialogStyles.dialog
    }
  }, children);
};
export default DesktopDialog;